import type { LocalizedValue } from '~/utils/common';

export enum ProductSort {
  LAST_MODIFIED = 'last_modified',
  NAME = 'name',
  NEWEST = 'newest',
  PRICE = 'price',
}

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export interface Category {
  categories?: Category[];
  description?: LocalizedValue;
  id: string;
  meta_description?: LocalizedValue;
  meta_title?: LocalizedValue;
  name: LocalizedValue;
  rank: number;
  slug: LocalizedValue;
}
